import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { __privateAdd, __privateGet, __privateSet, __privateWrapper } from "./chunk-PXG64RU4.js"; // src/mutationCache.ts

import { notifyManager } from "./notifyManager.js";
import { Mutation } from "./mutation.js";
import { matchMutation, noop } from "./utils.js";
import { Subscribable } from "./subscribable.js";

var _mutations, _scopes, _mutationId;

var MutationCache = /*#__PURE__*/function (_Subscribable) {
  function MutationCache() {
    var _this2;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MutationCache);

    _this2 = _callSuper(this, MutationCache);
    _this2.config = config;

    __privateAdd(_this2, _mutations);

    __privateAdd(_this2, _scopes);

    __privateAdd(_this2, _mutationId);

    __privateSet(_this2, _mutations, /* @__PURE__ */new Set());

    __privateSet(_this2, _scopes, /* @__PURE__ */new Map());

    __privateSet(_this2, _mutationId, 0);

    return _this2;
  }

  _inherits(MutationCache, _Subscribable);

  return _createClass(MutationCache, [{
    key: "build",
    value: function build(client, options, state) {
      var mutation = new Mutation({
        mutationCache: this,
        mutationId: ++__privateWrapper(this, _mutationId)._,
        options: client.defaultMutationOptions(options),
        state: state
      });
      this.add(mutation);
      return mutation;
    }
  }, {
    key: "add",
    value: function add(mutation) {
      __privateGet(this, _mutations).add(mutation);

      var scope = scopeFor(mutation);

      if (typeof scope === "string") {
        var scopedMutations = __privateGet(this, _scopes).get(scope);

        if (scopedMutations) {
          scopedMutations.push(mutation);
        } else {
          __privateGet(this, _scopes).set(scope, [mutation]);
        }
      }

      this.notify({
        type: "added",
        mutation: mutation
      });
    }
  }, {
    key: "remove",
    value: function remove(mutation) {
      if (__privateGet(this, _mutations).delete(mutation)) {
        var scope = scopeFor(mutation);

        if (typeof scope === "string") {
          var scopedMutations = __privateGet(this, _scopes).get(scope);

          if (scopedMutations) {
            if (scopedMutations.length > 1) {
              var index = scopedMutations.indexOf(mutation);

              if (index !== -1) {
                scopedMutations.splice(index, 1);
              }
            } else if (scopedMutations[0] === mutation) {
              __privateGet(this, _scopes).delete(scope);
            }
          }
        }
      }

      this.notify({
        type: "removed",
        mutation: mutation
      });
    }
  }, {
    key: "canRun",
    value: function canRun(mutation) {
      var scope = scopeFor(mutation);

      if (typeof scope === "string") {
        var mutationsWithSameScope = __privateGet(this, _scopes).get(scope);

        var firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find(function (m) {
          return m.state.status === "pending";
        });
        return !firstPendingMutation || firstPendingMutation === mutation;
      } else {
        return true;
      }
    }
  }, {
    key: "runNext",
    value: function runNext(mutation) {
      var _a;

      var scope = scopeFor(mutation);

      if (typeof scope === "string") {
        var _ref;

        var foundMutation = (_a = __privateGet(this, _scopes).get(scope)) == null ? void 0 : _a.find(function (m) {
          return m !== mutation && m.state.isPaused;
        });
        return (_ref = foundMutation == null ? void 0 : foundMutation.continue()) !== null && _ref !== void 0 ? _ref : Promise.resolve();
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      notifyManager.batch(function () {
        __privateGet(_this3, _mutations).forEach(function (mutation) {
          _this3.notify({
            type: "removed",
            mutation: mutation
          });
        });

        __privateGet(_this3, _mutations).clear();

        __privateGet(_this3, _scopes).clear();
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return Array.from(__privateGet(this, _mutations));
    }
  }, {
    key: "find",
    value: function find(filters) {
      var defaultedFilters = _objectSpread({
        exact: true
      }, filters);

      return this.getAll().find(function (mutation) {
        return matchMutation(defaultedFilters, mutation);
      });
    }
  }, {
    key: "findAll",
    value: function findAll() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.getAll().filter(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this4 = this;

      notifyManager.batch(function () {
        _this4.listeners.forEach(function (listener) {
          listener(event);
        });
      });
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      var pausedMutations = this.getAll().filter(function (x) {
        return x.state.isPaused;
      });
      return notifyManager.batch(function () {
        return Promise.all(pausedMutations.map(function (mutation) {
          return mutation.continue().catch(noop);
        }));
      });
    }
  }]);
}(Subscribable);

_mutations = new WeakMap();
_scopes = new WeakMap();
_mutationId = new WeakMap();

function scopeFor(mutation) {
  var _a;

  return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}

export { MutationCache };